"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeSwitcherProvider = void 0;
var _react = require("react");
var _hooksTs = require("@gogame/hooks-ts");
var _styles = require("@mui/material/styles");
var _ThemeSwitcherContext = require("./ThemeSwitcherContext");
var _constants = require("./constants");
var _components = require("./setups/components");
var _dark = require("./setups/dark");
var _light = require("./setups/light");
var _typography = require("./setups/typography");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ThemeSwitcherProvider = exports.ThemeSwitcherProvider = function ThemeSwitcherProvider(_ref) {
  var children = _ref.children,
    _ref$lightPalette = _ref.lightPalette,
    lightPalette = _ref$lightPalette === void 0 ? _light.lightPalette : _ref$lightPalette,
    _ref$darkPalette = _ref.darkPalette,
    darkPalette = _ref$darkPalette === void 0 ? _dark.darkPalette : _ref$darkPalette,
    activeThemeIdProp = _ref.activeThemeId;
  var _useLocalStorageState = (0, _hooksTs.useLocalStorageState)(_constants.LOCAL_STORAGE_KEY),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    activeThemeIdLocalStorage = _useLocalStorageState2[0],
    setActiveThemeId = _useLocalStorageState2[1];
  var activeThemeId = activeThemeIdLocalStorage || activeThemeIdProp || _constants.SYSTEM_THEME_ID;
  var theme = (0, _react.useMemo)(function () {
    var _window;
    var isDarkSystemMode = (_window = window) === null || _window === void 0 || (_window = _window.matchMedia('(prefers-color-scheme: dark)')) === null || _window === void 0 ? void 0 : _window.matches;
    var palette;
    switch (activeThemeId) {
      case _constants.LIGHT_THEME_ID:
        palette = lightPalette;
        break;
      case _constants.DARK_THEME_ID:
        palette = darkPalette;
        break;
      case _constants.SYSTEM_THEME_ID:
        palette = isDarkSystemMode ? darkPalette : lightPalette;
        break;
      default:
        palette = isDarkSystemMode ? darkPalette : lightPalette;
    }
    return (0, _styles.createTheme)({
      typography: _typography.typography,
      palette: palette,
      components: (0, _components.getComponents)(palette),
      mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: palette.background.paper,
          // Headers, and top & bottom fixed rows
          containerBackground: palette.background.paper
        }
      }
    });
  }, [activeThemeId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeSwitcherContext.ThemeSwitcherContext.Provider, {
    value: {
      activeThemeId: activeThemeId,
      theme: theme,
      setActiveThemeId: setActiveThemeId
    },
    children: children
  });
};